// extracted by mini-css-extract-plugin
module.exports = {"BooksOutlineLabel":"BooksOutlineLabel_BooksOutlineLabel__-f5Qp"};